/**
 * Pure consent-gate predicate for non-essential attribution writes
 * (the `referralCode` and `rb_gclid` cookies and their localStorage mirrors,
 * written by components/referral-capture.tsx).
 *
 * Consent state comes from lib/consent (`getAnalyticsConsent()`), which
 * returns 'accepted' | 'rejected' | null; the useConsent hook additionally
 * reports 'pending' before hydration. The mapping:
 *
 *   'accepted'         -> 'write'  write the real cookie + localStorage mirror
 *   null / 'pending'   -> 'stage'  hold the captured value in sessionStorage
 *                                  and promote it if consent later becomes
 *                                  'accepted'
 *   'rejected'         -> 'drop'   never write, and clear any staged values
 *
 * Client-safe and side-effect free; the referral-capture component performs
 * the actual storage operations.
 */
export type AttributionConsentState = 'accepted' | 'rejected' | 'pending' | null;

export type AttributionWriteAction = 'write' | 'stage' | 'drop';

export function attributionWriteAction(
  consent: AttributionConsentState,
): AttributionWriteAction {
  if (consent === 'accepted') return 'write';
  if (consent === 'rejected') return 'drop';
  return 'stage';
}
